import { LoginPage } from 'app/pages/LoginPage';
import { NotFoundPage } from 'app/pages/NotFoundPage';

export const PublicRoutes = [
  { path: '/login', element: <LoginPage /> },
  { path: '/', element: <LoginPage /> },
  { path: '*', element: <NotFoundPage /> },
];
